import React from 'react';
import styled, { css } from 'styled-components';
import { withSpacing } from '../lib/hoc/withSpacing';
import { padding, shade, themify, tint } from '../styles/mixins';
import { Tooltip } from './Tooltip';

const labelColor = label => {
  if (label === '?') return themify('grayDark');
  if (label.includes('A')) return themify('labels.a');
  return themify(`labels.${label.toLowerCase()}`);
};

const StyledEnergyLabel = styled.span.withConfig({
  displayName: "EnergyLabel__StyledEnergyLabel",
  componentId: "sc-1fjhln-0"
})(["position:relative;display:inline-block;vertical-align:", ";color:white;text-align:center;font-weight:bold;font-size:", ";transition:0.2s background ", ";text-shadow:0.05em 0.05em ", ";min-width:2em;height:2em;line-height:2em;border-radius:100px;", ";", ";", ";", ";", ";"], x => x.$verticalAlign, x => x.$fontSize ? x.theme.type.scale[x.$fontSize] : 'inherit', x => x.theme.curves.standard, x => shade(0.8, labelColor(x.$label)), padding(1, 'x'), x => x.$labelType === 'estimated' && css(["background:", ";background-size:9.9px 9.9px;"], `linear-gradient(45deg, ${labelColor(x.$label)} 21.43%, ${tint(0.8, labelColor(x.$label))} 21.43%, ${tint(0.8, labelColor(x.$label))} 50%, ${labelColor(x.$label)} 50%, ${labelColor(x.$label)} 71.43%, ${tint(0.8, labelColor(x.$label))} 71.43%, ${tint(0.8, labelColor(x.$label))} 100%)`), x => x.$labelType === 'preliminary' && css(["background:", ";&::before{content:'';position:absolute;left:0;right:0;height:100%;border:6px double ", ";border-radius:50%;}"], labelColor(x.$label), tint(0.8, labelColor(x.$label))), x => (x.$labelType === 'registered' || !x.$labelType) && css(["background:", ";"], labelColor(x.$label)), x => x.$labelType === 'indicated' && css(["background:", ";background-size:9.9px 9.9px;"], `linear-gradient(90deg, ${labelColor(x.$label)} 21.43%, ${tint(0.8, labelColor(x.$label))} 21.43%, ${tint(0.8, labelColor(x.$label))} 50%, ${labelColor(x.$label)} 50%, ${labelColor(x.$label)} 71.43%, ${tint(0.8, labelColor(x.$label))} 71.43%, ${tint(0.8, labelColor(x.$label))} 100%)`));

const EnergyLabelFunc = ({
  className,
  isEstimate,
  fontSize = 5,
  label,
  labelType,
  hideTooltip = false,
  verticalAlign = 'middle'
}) => {
  let tooltipContent = 'Onze indicatie';
  if (labelType === 'indicated') tooltipContent = 'Indicatie van RVO';
  if (labelType === 'preliminary') tooltipContent = 'Voorlopig label volgens RVO';
  if (labelType === 'registered') tooltipContent = 'Geregistreerd bij RVO';
  const renderedLabel = /*#__PURE__*/React.createElement(StyledEnergyLabel, {
    className: className,
    $fontSize: fontSize,
    $label: label,
    $labelType: isEstimate ? 'estimated' : labelType,
    $verticalAlign: verticalAlign
  }, label);
  return hideTooltip || !labelType && !isEstimate ? renderedLabel : /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipContent,
    bgColor: labelColor(label)
  }, renderedLabel);
};

export const EnergyLabel = withSpacing(EnergyLabelFunc);